import {IQuestionData} from './question-data';
import {IQuestionType} from './question-type';

export const QuestionDefault: IQuestionData = {
    id: undefined,
    tempId: '',
    name: '',
    info: '',
    pitTag: '',
    type: IQuestionType.TEXT,
    textAnswerLength: 1024,
    allowAttachments: false,
    isRequired: true,
    possibleAnswers: [],
    dependentQuestion: null,
    title: '',
    question: '',
    maxValue: null,
    minValue: null,
    defaultValue: '',
    showExplanation: false,
    isMultiAnswer: false,
};
